@let $title = title();
@let $titleClasses = computedTitleClasses();

@if ($title) {
  <header class="mbs-form-section_header">
    @switch (titleSize()) {
      @case ('h1') {
        <h1
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          <ng-container [ngTemplateOutlet]="tagTemplate" />
        </h1>
      }
      @case ('h2') {
        <h2
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          <ng-container [ngTemplateOutlet]="tagTemplate" />
        </h2>
      }
      @case ('h3') {
        <h3
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          <ng-container [ngTemplateOutlet]="tagTemplate" />
        </h3>
      }
      @case ('h4') {
        <h4
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          <ng-container [ngTemplateOutlet]="tagTemplate" />
        </h4>
      }
      @case ('h5') {
        <h5
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          <ng-container [ngTemplateOutlet]="tagTemplate" />
        </h5>
      }
      @case ('h6') {
        <h6
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          <ng-container [ngTemplateOutlet]="tagTemplate" />
        </h6>
      }
      @default {
        <h5
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          <ng-container [ngTemplateOutlet]="tagTemplate" />
        </h5>
      }
    }
  </header>

  <ng-template #tagTemplate>
    @if (icon(); as icon) {
      <span [class]="'mbs-form-section_header-ico ' + icon"></span>
    }
    {{ $title }}
  </ng-template>
}

<div class="mbs-form-section_content">
  <ng-content />
</div>
